const STEPS = [
  {
    icon: '🗳️',
    title: 'Välj parti',
    body: 'Välj ett av riksdagens åtta partier när du startar appen. Det bestämmer din färg på kartan och vilka distrikt du kämpar om.',
  },
  {
    icon: '🗺️',
    title: 'Läs kartan',
    body: 'Sverige är indelat i drygt 6 000 kommunvalkretsar. Grått är neutralt, färg visar att ett parti kontrollerar distriktet, och ju mer erövrat desto mörkare.',
  },
  {
    icon: '📍',
    title: 'Kampanja på plats',
    body: 'Det vanligaste sättet att kampanja är på plats: GPS verifierar att du faktiskt står i distriktet. Vill du nå längre bort finns även möjligheten att ringa väljare på distans (se nedan).',
  },
  {
    icon: '⚡',
    title: 'Mobilisera',
    body: 'Tryck på ett distrikt och välj Mobilisera (kostar 10 partistöd). Du får ett slumpmässigt minispel att klara på tio sekunder. Ju bättre du presterar, desto fler omvänds. Når ni 50 % av befolkningen tar ni över distriktet!',
  },
  {
    icon: '⚔️',
    title: 'Välj din motståndare',
    body: 'Är alla neutrala röstare borta? Vinn minispelet och välj sedan vilket parti som förlorar anhängare till dig. Taktiken är din!',
  },
  {
    icon: '💰',
    title: 'Håll dig aktiv',
    body: 'Du får 50 partistöd per dag. Erövrade distrikt ger bonus efter befolkningsstorlek. Slut på partistöd? Du kan spela gratisspelet flera gånger per dag. Stoppa nålen i rätt zon och tjäna 10 stöd per träff. Spela i valfritt distrikt, och gratisomgångarna återladdas regelbundet!',
  },
  {
    icon: '🍀',
    title: 'Samla partiklöver',
    body: 'Spela varje dag och bygg din streak för att tjäna partiklöver — en andra valuta vid sidan av partistödet. Ju längre obruten svit, desto större belöning.',
  },
  {
    icon: '🎡',
    title: 'Snurra tombolan',
    body: 'Satsa dina partiklöver i tombolan och vinn partistöd — kanske till och med en jackpot. Du hittar hjulet under din profil.',
  },
  {
    icon: '📞',
    title: 'Ring väljare',
    body: 'Långt till nya distrikt? Ring väljare och kampanja på distans i valfri valkrets. Det kostar partiklöver istället för att du måste vara på plats.',
  },
  {
    icon: '🏆',
    title: 'Utmärkelser',
    body: 'Lås upp utmärkelser för allt du gör: erövra distrikt, kampanja i nya kommuner och klara svårt läge. Se dina framsteg under din profil.',
  },
];

export function HowItWorks() {
  return (
    <section className="how-it-works" id="sa-funkar-det">
      <h2>Så funkar det</h2>
      <div className="how-grid">
        {STEPS.map((step, i) => (
          <div className="how-card" key={step.title}>
            <div className="how-step-number">{i + 1}</div>
            <div className="how-icon">{step.icon}</div>
            <h3>{step.title}</h3>
            <p>{step.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
